import { CondominiosListRoute } from '@/routes/condominios';

export function PlatformHomeRoute() {
  return <CondominiosListRoute />;
}
